import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { pushSubscribe, pushUnsubscribe, getFirebaseConfiguration, getSubscriptionStatus} from "../api/webpush";

/*
const firebaseConfig = {
        apiKey: "AIzaSyBHTt2rs3dTYekZFCXKY5X6wryhlTqtxAY",
        authDomain: "test-x20-1523615315752.firebaseapp.com",
        projectId: "test-x20-1523615315752",
        storageBucket: "test-x20-1523615315752.firebasestorage.app",
        messagingSenderId: "834078419526",
        appId: "1:834078419526:web:2626527894c60ad1f6f847",
        measurementId: "G-GXS17LMJBS"
      };
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);*/
let messaging = null;
let vapidKey = null;
export const initializeWebPush = () => {
  getFirebaseConfiguration().then((result) => {
    if (result !== null && result !== undefined)
    {
      let app = initializeApp(result.firebaseConfig);
      messaging = getMessaging(app);
      vapidKey = result.vapidKey;
    }
  })
}

export const subscribeDevice = async(callback) => {
   if(!isAvailable())
   {
     return;
   }
   const permission = await Notification.requestPermission();
   console.log('SubscribeDevice');
   console.log(permission);    
   if(permission === 'granted')
   {
      navigator.serviceWorker.getRegistration().then((registration) => (
        getToken(messaging, { /*vapidKey: 'BGG4gXD1otubK5XiAI34O1eVxaKxry8zWhkgxublS4wDvY90nR3lH2BCNCJTpScE7Wv4dilv8LAF6P7uqcDzTPc',*/
                              vapidKey: vapidKey,
                              serviceWorkerRegistration : registration
        }).then((currentToken) => {
          console.log('getToken');
          console.log(currentToken);    
          if (currentToken) {
              registration.pushManager.getSubscription().then((subscription) => {
                console.log('getSubscription');
                console.log(subscription);    
                if(subscription)
                {
                    pushSubscribe({token: currentToken, userAgent: navigator.userAgent, endPoint: subscription.endpoint});
                }
              });
          } else {
            console.log('No registration token available. Request permission to generate one.');
          }
        }).catch((err) => {
          console.log('An error occurred while retrieving token. ', err);
        })));
   }
   callback(permission);
}
    
export const unsubscribeDevice = async(callback) => {
    navigator.serviceWorker.getRegistration().then((registration) => {
        registration.pushManager.getSubscription().then((subscription) => {
            if(subscription)
            {
                pushUnsubscribe(subscription.endpoint);
                callback('default');
            }
        });
    });
}

export const subscriptionStatus = async(callback) => {
    const permission = Notification.permission;
    if(permission === 'granted')
    {
        navigator.serviceWorker.getRegistration().then((registration) => {
          registration.pushManager.getSubscription().then((subscription) => {
              if(subscription)
              {
                  getSubscriptionStatus(subscription.endpoint).then(res => {
                      console.log(res);
                      callback(res.status);
                  });
              }
          });
      });
    }
    else
    {
        callback(permission);
    }
}

export const isAvailable = () => {
  return messaging !== null;
}
